var React = require('react');

function LogoZenreach (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"logo_zenreach"),React.createElement("rect",{"width":"395.28251","height":"395.28251","style":{"fill":"#ee2c3e"},"key":1}),React.createElement("path",{"d":"M325.55593,69.8622V269.35451H125.90313V250.75438c31.04406-32.18124,61.45066-63.70167,91.55548-94.90924H125.91582V126.01282H269.37215v18.5547q-46.53661,48.19412-91.33266,94.58564h118.901V98.46938H98.41108V297.21053h227.084v28.2251H69.85454V69.8622Z","style":{"fill":"#fff"},"key":2})]);
}

LogoZenreach.defaultProps = {"viewBox":"0 0 395.28251 395.28251"};

module.exports = LogoZenreach;

LogoZenreach.default = LogoZenreach;
